module.exports = __webpack_public_path__ + "img/Middle_Exhibition_Logo.4e366661.jpg";